import { render, staticRenderFns } from "./ModalCreateCodPostal.vue?vue&type=template&id=0ecd5986&scoped=true"
import script from "./ModalCreateCodPostal.vue?vue&type=script&lang=js"
export * from "./ModalCreateCodPostal.vue?vue&type=script&lang=js"
import style0 from "vue-multiselect/dist/vue-multiselect.min.css?vue&type=style&index=0&prod&lang=css&external"
import style1 from "./ModalCreateCodPostal.vue?vue&type=style&index=1&id=0ecd5986&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "0ecd5986",
  null
  
)

export default component.exports